<script>
const SVG_LIB = { 
  "add": {
    id: `add`,
    class: [
      `icon`,
      `icon--add`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/> `,
  },
  "fastfood": {
    id: `fastfood`,
    class: [
      `icon`,
      `icon--fastfood`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M18.06 22.99h1.66c.84 0 1.53-.64 1.63-1.46L23 5.05h-5V1h-1.97v4.05h-4.97l.3 2.34c1.71.47 3.31 1.32 4.27 2.26 1.44 1.42 2.43 2.89 2.43 5.29v8.05zM1 21.99V21h15.03v.99c0 .55-.45 1-1.01 1H2.01c-.56 0-1.01-.45-1.01-1zm15.03-7c0-8-15.03-8-15.03 0h15.03zM1.02 17h15v2h-15z"/> `,
  },
  "person": {
    id: `person`,
    class: [
      `icon`,
      `icon--person`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/> `,
  },
  "person-add": {
    id: `person-add`,
    class: [
      `icon`,
      `icon--person-add`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/> `,
  },
  "remove-shopping-cart": {
    id: `remove-shopping-cart`,
    class: [
      `icon`,
      `icon--remove-shopping-cart`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38A1.997 1.997 0 0 0 17 22c.67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"/> `,
  },
  "settings": {
    id: `settings`,
    class: [
      `icon`,
      `icon--settings`,
    ],
    preserveAspectRatio: ``,
    width: {size: 20, unit: `px`},
    height: {size: 20, unit: `px`},
    'viewBox': `0 0 20 20`,
    content: ` <path d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34a.4.4 0 0 0-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"/> `,
  },
  "beer": {
    id: `beer`,
    class: [
      `icon`,
      `icon--beer`,
    ],
    preserveAspectRatio: ``,
    width: {size: 48, unit: `px`},
    height: {size: 72, unit: `px`},
    'viewBox': `0 0 48 72`,
    content: `<defs><clipPath id="beer-a"> <path d="M20.348 12.333a.783.783 0 0 1-.007-.108c0-1.01 1.64-1.83 3.659-1.83s3.659.82 3.659 1.83a.783.783 0 0 1-.007.108l.007.001s.158 5.111.912 8.123c.702 2.811 3.736 6.887 3.736 13.128 0 .127-.004.253-.012.376h.012v31.095h-.003c-.116 2.242-3.792 4.045-8.304 4.045-4.512 0-8.188-1.803-8.304-4.045h-.003V33.961h.012a5.808 5.808 0 0 1-.012-.376c0-6.241 3.034-10.317 3.736-13.128.754-3.012.912-8.123.912-8.123l.007-.001z"/> </clipPath></defs> <path d="M19.549 8.217c-.479-.498-.754-1.082-.754-1.707 0-1.817 2.332-3.292 5.205-3.292s5.205 1.475 5.205 3.292c0 .625-.275 1.209-.754 1.707.479.498.754 1.082.754 1.706 0 1.818-2.332 3.293-5.205 3.293s-5.205-1.475-5.205-3.293c0-.624.275-1.208.754-1.706z"/> <path d="M20.348 12.333a.783.783 0 0 1-.007-.108c0-1.01 1.64-1.83 3.659-1.83s3.659.82 3.659 1.83a.783.783 0 0 1-.007.108l.007.001s.158 5.111.912 8.123c.702 2.811 3.736 6.887 3.736 13.128 0 .127-.004.253-.012.376h.012v31.095h-.003c-.116 2.242-3.792 4.045-8.304 4.045-4.512 0-8.188-1.803-8.304-4.045h-.003V33.961h.012a5.808 5.808 0 0 1-.012-.376c0-6.241 3.034-10.317 3.736-13.128.754-3.012.912-8.123.912-8.123l.007-.001z"/> <g clip-path="url(#beer-a)"> <path d="M15.693 10.431h.003c.116 2.243 3.792 4.045 8.304 4.045 4.512 0 8.188-1.802 8.304-4.045h.003v6.255h-.003c-.116 2.242-3.792 4.044-8.304 4.044-4.512 0-8.188-1.802-8.304-4.044h-.003v-6.255z" class="icon-secondary-color"/> </g> <path d="M18.453 36.745A6.06 6.06 0 0 1 24 33.122a6.06 6.06 0 0 1 5.547 3.623c1.643-.738 2.696-1.799 2.757-2.982h.003v21.741h-.003c-.116 2.242-3.792 4.045-8.304 4.045-4.512 0-8.188-1.803-8.304-4.045h-.003V33.763h.003c.061 1.183 1.114 2.244 2.757 2.982z" class="icon-secondary-color"/> `,
  },
  "bucket": {
    id: `bucket`,
    class: [
      `icon`,
      `icon--bucket`,
    ],
    preserveAspectRatio: ``,
    width: {size: 48, unit: `px`},
    height: {size: 72, unit: `px`},
    'viewBox': `0 0 48 72`,
    content: ` <path d="M5.1 32.445a4.833 4.833 0 0 1-.01-.319c0-5.532 8.304-10.024 18.532-10.024 10.227 0 18.531 4.492 18.531 10.024 0 .107-.003.213-.009.319h.009l-.017.115a5.568 5.568 0 0 1-.116.77l-4.128 27.546-.005.035-.002.013-.051.344h-.017c-.908 3.801-6.922 6.742-14.195 6.742-7.274 0-13.287-2.941-14.196-6.742h-.012l-.028-.184a4.21 4.21 0 0 1-.055-.369L5.223 33.332a5.608 5.608 0 0 1-.115-.773l-.018-.114h.01z"/> <path d="M8.622 38.01c.619-1.53 1.891-2.722 3.448-3.171.639-2.217 2.786-3.856 5.268-3.856 2.154 0 4.057 1.236 4.939 3.012.582-1.082 1.565-1.91 2.734-2.247.548-1.9 2.389-3.306 4.516-3.306 2.127 0 3.968 1.406 4.516 3.306 1.783.514 3.131 2.166 3.29 4.125a4.52 4.52 0 0 1 2.124 1.459c-3.254 2.888-9.131 4.818-15.835 4.818-6.165 0-11.631-1.632-15-4.14z" class="icon-secondary-color"/> `,
  },
  "glass": {
    id: `glass`,
    class: [
      `icon`,
      `icon--glass`,
    ],
    preserveAspectRatio: ``,
    width: {size: 48, unit: `px`},
    height: {size: 55, unit: `px`},
    'viewBox': `0 0 48 55`,
    content: ` <path d="M39.429 10.286h-5.143V6a2.572 2.572 0 0 0-2.572-2.571H2.571A2.57 2.57 0 0 0 0 6v42.857a2.572 2.572 0 0 0 2.571 2.572h29.143a2.573 2.573 0 0 0 2.572-2.572v-4.512l8.636-3.854A8.58 8.58 0 0 0 48 32.664V18.857c0-4.726-3.845-8.571-8.571-8.571zm1.714 22.378a1.719 1.719 0 0 1-1.016 1.565l-5.841 2.607V17.143h5.143c.945 0 1.714.769 1.714 1.714v13.807zm-18.857 8.479a1.715 1.715 0 0 1-1.715-1.714v-24a1.715 1.715 0 0 1 3.429 0v24c0 .946-.768 1.714-1.714 1.714zm-10.286 0a1.714 1.714 0 0 1-1.714-1.714v-24a1.714 1.714 0 1 1 3.428 0v24c0 .946-.767 1.714-1.714 1.714z" fill-rule="nonzero"/> `,
  },
  "new-night": {
    id: `new-night`,
    class: [
      `icon`,
      `icon--new-night`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M13.084 24c3.692 0 7.078-1.678 9.321-4.443 1.325-1.632-.12-4.018-2.168-3.628-3.86.735-7.419-2.215-7.419-6.131a6.239 6.239 0 0 1 3.161-5.429C17.795 3.335 17.339.582 15.275.2a12.1 12.1 0 0 0-2.191-.2c-6.626 0-12 5.371-12 12 0 6.626 5.371 12 12 12zm0-21.75a9.77 9.77 0 0 1 1.782.163 8.49 8.49 0 0 0-4.298 7.385c0 5.337 4.859 9.338 10.09 8.341a9.728 9.728 0 0 1-7.574 3.611c-5.384 0-9.75-4.365-9.75-9.75s4.366-9.75 9.75-9.75z" fill-rule="nonzero"/> <path d="M24 10h-4v4h-2v-4h-4V8h4V4h2v4h4v2z"/> `,
  },
  "night": {
    id: `night`,
    class: [
      `icon`,
      `icon--night`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M13.084 24c3.692 0 7.078-1.678 9.321-4.443 1.325-1.632-.12-4.018-2.168-3.628-3.86.735-7.419-2.215-7.419-6.131a6.239 6.239 0 0 1 3.161-5.429C17.795 3.335 17.339.582 15.275.2a12.1 12.1 0 0 0-2.191-.2c-6.626 0-12 5.371-12 12 0 6.626 5.371 12 12 12zm0-21.75a9.77 9.77 0 0 1 1.782.163 8.49 8.49 0 0 0-4.298 7.385c0 5.337 4.859 9.338 10.09 8.341a9.728 9.728 0 0 1-7.574 3.611c-5.384 0-9.75-4.365-9.75-9.75s4.366-9.75 9.75-9.75z" fill-rule="nonzero"/> `,
  },
  "add-circle": {
    id: `add-circle`,
    class: [
      `icon`,
      `icon--add-circle`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/> `,
  },
  "close": {
    id: `close`,
    class: [
      `icon`,
      `icon--close`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/> `,
  },
  "color-lens": {
    id: `color-lens`,
    class: [
      `icon`,
      `icon--color-lens`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <g> <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0 1 12 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 0 0-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 0 1 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"/> <circle cx="6.5" cy="11.5" r="1.5"/> <circle cx="9.5" cy="7.5" r="1.5"/> <circle cx="14.5" cy="7.5" r="1.5"/> <circle cx="17.5" cy="11.5" r="1.5"/> </g> `,
  },
  "delete-forever": {
    id: `delete-forever`,
    class: [
      `icon`,
      `icon--delete-forever`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <g> <path d="M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/> <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z"/> </g> `,
  },
  "edit": {
    id: `edit`,
    class: [
      `icon`,
      `icon--edit`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <g> <path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"/> </g> `,
  },
  "info": {
    id: `info`,
    class: [
      `icon`,
      `icon--info`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M11 7h2v2h-2zM11 11h2v6h-2z"/> <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/> `,
  },
  "remove-circle": {
    id: `remove-circle`,
    class: [
      `icon`,
      `icon--remove-circle`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/> `,
  },
  "save": {
    id: `save`,
    class: [
      `icon`,
      `icon--save`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"/> `,
  },
  "promotion": {
    id: `promotion`,
    class: [
      `icon`,
      `icon--promotion`,
    ],
    preserveAspectRatio: ``,
    width: {size: 72, unit: `px`},
    height: {size: 72, unit: `px`},
    'viewBox': `0 0 72 72`,
    content: ` <path d="M8.773 62.694a3.898 3.898 0 0 0 3.902 3.902h19.506V47.089H8.773v15.605zM39.983 66.596h19.506a3.898 3.898 0 0 0 3.902-3.902V47.089H39.983v19.507zM58.258 27.583h5.133a3.898 3.898 0 0 1 3.901 3.902v9.753c0 1.072-.878 1.95-1.951 1.95H6.823a1.957 1.957 0 0 1-1.951-1.95v-9.753a3.897 3.897 0 0 1 3.901-3.902h49.485z"/> <path d="M23.635 27.583H14.15c-.768-1.475-1.232-3.109-1.232-4.876 0-5.913 4.816-10.729 10.729-10.729 5.071 0 8.351 2.597 12.557 8.327 4.206-5.73 7.485-8.327 12.557-8.327 5.913 0 10.728 4.816 10.728 10.729 0 1.767-.475 3.401-1.231 4.876h-9.497a4.875 4.875 0 0 0 4.876-4.876 4.875 4.875 0 0 0-4.876-4.877c-2.487 0-4.23.427-10.497 9.753h-4.133c-6.278-9.35-8.07-9.753-10.496-9.753a4.876 4.876 0 0 0-4.877 4.877 4.875 4.875 0 0 0 4.877 4.876z" class="icon-secondary-color"/> `,
  },
  "store": {
    id: `store`,
    class: [
      `icon`,
      `icon--store`,
    ],
    preserveAspectRatio: ``,
    width: {size: 24, unit: `px`},
    height: {size: 24, unit: `px`},
    'viewBox': `0 0 24 24`,
    content: ` <path d="M0 9.75c0 1.396.958 2.559 2.25 2.895V22.5H.75a.75.75 0 0 0 0 1.5h22.5c.416 0 .75-.335.75-.75a.748.748 0 0 0-.75-.75h-1.5v-9.855A2.995 2.995 0 0 0 24 9.75V9H0v.75zm15 3a3 3 0 0 0 3-3c0 1.396.958 2.559 2.25 2.895V22.5H9v-9.75a3 3 0 0 0 3-3c0 1.657 1.345 3 3 3zm-6.75-.105V22.5h-4.5v-9.855A2.995 2.995 0 0 0 6 9.75c0 1.396.958 2.559 2.25 2.895zM21 2.25H3l-3 6h24l-3-6zM3 .75A.75.75 0 0 1 3.75 0h16.5c.416 0 .75.335.75.75s-.334.75-.75.75H3.75A.75.75 0 0 1 3 .75z" fill-rule="nonzero"/> `,
  },
  "water": {
    id: `water`,
    class: [
      `icon`,
      `icon--water`,
    ],
    preserveAspectRatio: ``,
    width: {size: 48, unit: `px`},
    height: {size: 72, unit: `px`},
    'viewBox': `0 0 48 72`,
    content: ` <path d="M19.838 20.382a.582.582 0 0 1-.007-.093c0-.867 1.868-1.57 4.169-1.57 2.301 0 4.169.703 4.169 1.57a.582.582 0 0 1-.007.093l.007.001s.181 4.386 1.04 6.971c.801 2.413 4.258 5.911 4.258 11.266 0 .11-.005.217-.014.323h.014v26.686h-.003c-.133 1.925-4.322 3.472-9.464 3.472s-9.331-1.547-9.464-3.472h-.003V38.943h.014a3.803 3.803 0 0 1-.014-.323c0-5.355 3.457-8.853 4.258-11.266.859-2.585 1.04-6.971 1.04-6.971l.007-.001z"/> <ellipse cx="24" cy="17.957" rx="5.605" ry="3.546" class="icon-secondary-color"/> <path d="M34.231 10.292c1.245.056 2.495.716 2.858 1.963.965 3.307-3.874 7.336-7.471 6.133-.793-.265-1.469-.874-1.737-1.68-1.023-3.069 2.875-6.494 6.35-6.416zm-.191 1.497c-3.308.073-6.858 5.167-3.28 5.288 2.043.069 4.23-1.394 4.839-3.389.261-.855-.298-1.899-1.559-1.899z" fill-rule="nonzero"/> <path d="M29.685 43.514a2.844 2.844 0 0 0-2.842-2.843h-5.686a2.844 2.844 0 0 0-2.842 2.843v14.493a2.843 2.843 0 0 0 2.842 2.842h5.686a2.843 2.843 0 0 0 2.842-2.842V43.514z" class="icon-secondary-color"/> `,
  },
  "whisky": {
    id: `whisky`,
    class: [
      `icon`,
      `icon--whisky`,
    ],
    preserveAspectRatio: ``,
    width: {size: 48, unit: `px`},
    height: {size: 48, unit: `px`},
    'viewBox': `0 0 48 48`,
    content: ` <path d="M19.549 7.335c-.479-.498-.754-1.082-.754-1.707 0-1.817 2.332-3.292 5.205-3.292s5.205 1.475 5.205 3.292c0 .625-.275 1.209-.754 1.707.479.498.754 1.082.754 1.706 0 .966-.658 1.834-1.705 2.437.114.991.268 2.002.474 2.828.597 2.388 8.933 2.194 8.933 7.496v19.422h-.003c-.098 1.905-6.062 3.437-12.813 3.437-6.75 0-12.897-1.532-12.995-3.437h-.003V21.802c0-5.302 8.61-5.108 9.207-7.496.198-.79.338-1.75.438-2.699-1.184-.604-1.943-1.529-1.943-2.566 0-.624.275-1.208.754-1.706z"/> <path d="M11.093 25.664h.003c.098 1.904 6.245 3.436 12.995 3.436 6.75 0 12.714-1.532 12.813-3.436h.003v9.851h-.003c-.099 1.905-6.063 3.436-12.813 3.436-6.75 0-12.897-1.531-12.995-3.436h-.003v-9.851z" class="icon-secondary-color"/> `,
  },
}
const SVG_ATTRS = {
  "xmlns": false
}

export default {
  name: `svg-icon`,
  props: {
    name: {
      type: String,
      required: true,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    attrs() {
      if (!SVG_LIB[this.name]) return {} 
      const width = this.icon.width.size * this.scale + this.icon.width.unit
      const height = this.icon.height.size * this.scale + this.icon.height.unit 
      return Object.assign({
        viewBox: this.icon.viewBox,
        preserveAspectRatio: this.icon.preserveAspectRatio ? this.icon.preserveAspectRatio : false,
        width,
        height,
      }, SVG_ATTRS)
    },
    icon() {
      if (!SVG_LIB[this.name]) return {}
      return SVG_LIB[this.name]
    }
  },
  render(createElement) {
    if (!SVG_LIB[this.name]) return null
    return createElement(
      `svg`,
      {
        class: this.icon.class,
        attrs: this.attrs,
        domProps: {
          innerHTML: this.icon.content
        },
      }
    )
  },
}
</script>